// Submit Hub: lets user pick what to submit (Business / Event / Community)
import { Link } from 'react-router-dom';
import { Building2, Calendar, Users, ListChecks, ArrowRight, Sparkles } from 'lucide-react';
import { useAuth } from '../lib/AuthContext';
import { PremiumGate } from '../components/submitHelpers';

const OPTIONS = [
  {
    to: '/app/submit/business',
    title: 'Business',
    desc: 'A restaurant, salon, fashion brand, or service you own or love.',
    icon: Building2,
    color: '#E76F51',
    testid: 'submit-option-business',
  },
  {
    to: '/app/submit/event',
    title: 'Event',
    desc: 'Mixers, festivals, concerts, parties, networking nights.',
    icon: Calendar,
    color: '#E9C46A',
    testid: 'submit-option-event',
  },
  {
    to: '/app/submit/community',
    title: 'Community',
    desc: 'Social groups, sports leagues, professional networks, faith circles.',
    icon: Users,
    color: '#9B5DE5',
    testid: 'submit-option-community',
  },
];

export default function Submit() {
  const { user } = useAuth();
  const isPremium = user?.is_premium;

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-8" data-testid="submit-hub-page">
      <div className="mb-6">
        <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-[#FFE5DD] rounded-full mb-3">
          <Sparkles className="w-4 h-4 text-[#C8553D]" />
          <span className="text-xs font-bold uppercase tracking-wider text-[#C8553D]">Premium</span>
        </div>
        <h1 className="text-3xl md:text-4xl font-serif font-bold text-[#2B2D42]" style={{ fontFamily: 'Playfair Display, serif' }}>
          Submit a Listing
        </h1>
        <p className="text-[#6D6875] mt-2">
          Help grow the AfroConnect directory. Submissions are reviewed by our team before going live.
        </p>
      </div>

      {!isPremium && (
        <div className="mb-6">
          <PremiumGate message="Submissions are a Premium-only feature. Upgrade to add businesses, events, or communities to AfroConnect." />
        </div>
      )}

      <div className="space-y-3">
        {OPTIONS.map(({ to, title, desc, icon: Icon, color, testid }) => (
          <Link
            key={to}
            to={isPremium ? to : '#'}
            onClick={(e) => { if (!isPremium) e.preventDefault(); }}
            data-testid={testid}
            className={`flex items-center gap-4 p-5 bg-white border border-[#F4F1DE] rounded-2xl ${
              isPremium ? 'hover:bg-[#FFE5DD]/30 hover:border-[#E07A5F] transition-colors' : 'opacity-60 cursor-not-allowed'
            }`}
          >
            <div className="w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0" style={{ backgroundColor: color + '20' }}>
              <Icon className="w-6 h-6" style={{ color }} />
            </div>
            <div className="flex-1">
              <h3 className="text-lg font-serif font-bold text-[#2B2D42]" style={{ fontFamily: 'Playfair Display, serif' }}>{title}</h3>
              <p className="text-sm text-[#6D6875]">{desc}</p>
            </div>
            {isPremium && <ArrowRight className="w-5 h-5 text-[#C8553D]" />}
          </Link>
        ))}
      </div>

      <Link
        to="/app/my-submissions"
        data-testid="submit-view-my"
        className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-[#C8553D] hover:underline"
      >
        <ListChecks className="w-4 h-4" />
        View my submissions
      </Link>
    </div>
  );
}
